import { Component, Input, Output, EventEmitter, OnInit } from '@angular/core';
import { FormControl } from '@angular/forms';
import { faChevronDown } from '@fortawesome/free-solid-svg-icons';

export interface DropdownOption {
  id: string;
  name: string;
}

@Component({
  selector: 'app-dropdown',
  templateUrl: './dropdown.component.html',
  styleUrls: ['./dropdown.component.scss'],
  standalone: false
})
export class DropdownComponent implements OnInit {
  @Input() label?: string;
  @Input() labelClass?: string;
  @Input() placeholder?: string;
  @Input() options: DropdownOption[] = [];
  @Input() control: FormControl;
  @Input() starIcon?: any;
  @Input() borderColor: boolean = false;
  @Output() changeEvent: EventEmitter<any> = new EventEmitter<any>();

  faChevronDown = faChevronDown;

  constructor() {
    this.control = new FormControl('');
  }

  ngOnInit(): void {
    // Initialize with first option if available
    if (this.options.length > 0 && !this.control.value) {
      // this.control.setValue(this.options[0].id);
    }
  }
  
}
